module.exports = __webpack_public_path__ + "img/color_summer_clothes_square.4e82a15b.png";